import React from 'react';
import ImageSelector from './ImageSelector';
import SingleLineTextEditor, {SingleLineTextEditorProps} from './SingleLineTextEditor';
import TextareaEditor, {TextareaEditorProps} from "./TextareaEditor";
import {SelectedImageData} from "../../../context/TemplateContext";
import {ImageValue} from "../../../models/Template";

export interface CommonProps {
    elementKey: string;
    label: string; // Adjust the type as needed
    selectedDesignKey: string;
    // Assuming options is only for ImageSelector, it will not be part of CommonProps
}

interface ImageSelectorProps extends CommonProps {
    folderId: string;
    value: { name: string; highRes: string, thumbnail: string };
    onClick: (imageData: SelectedImageData) => void;
    onImageTransformClick: (key: string | undefined) => void;
    onImageTransformResetClick: (key: string, value: ImageValue) => void;
    allowImageTransform: boolean;
}

interface TextFieldProps extends CommonProps {
    maxChars: number;
    value: string;
    onChange: (...args: any[]) => void;
}

interface FormControlFactoryProps {
    type: 'image' | 'text' | 'textarea';
    // Spread the rest of the properties that match either ImageSelectorProps or TextEditorProps
}

const FormControlFactory: React.FC<FormControlFactoryProps &
    CommonProps &
    Partial<ImageSelectorProps> & Partial<TextFieldProps>> = ({
                                                                  type,
                                                                  ...props
                                                              }) => {
    // console.log("type", type, props)

    switch (type) {
        case 'image':
            return <ImageSelector {...props as ImageSelectorProps} />;
        case 'text':
            return <SingleLineTextEditor {...props as SingleLineTextEditorProps} />;
        case 'textarea':
            return <TextareaEditor {...props as TextareaEditorProps} />;
        default:
            return null;
    }
};
export default FormControlFactory;
